import { createUseStyles } from "react-jss";
import { colors } from "constants/colors";
import { breakpoints } from "constants/breakpoints";

const styles = createUseStyles({
  teamsTextContainer: {
    display: "grid",
    "& p": {
      margin: 0,
      fontSize: "18px",
      color: colors.lightBlack,
      fontWeight: "600",
      lineHeight: "28px",
    },
    "& span": {
      fontSize: "14px",
      color: colors.mediumGrey,
      fontWeight: "400",
      lineHeight: "20px",
    },
  },
  headerContainer: {
    display: "flex",
    marginTop: "32px",
    [`@media (max-width: ${breakpoints.md}px)`]: {
      display: "grid",
    },
  },
  downloadLoadingState: {
    backgroundColor: `${colors.brightBlue} !important`,
    pointerEvents: "none",
    border: `1px solid ${colors.brightBlue}`,
    '& span': {
      borderColor: `${colors.darkerGrey} ${colors.darkerGrey} transparent !important`
    }
  },
  downloadTeamsBtn: {
    height: "fit-content",
    border: "none",
    alignSelf: "center",
    marginLeft: "auto",
    "& svg": {
      "& path": {
        stroke: colors.mediumGrey,
      },
    },
    "&:hover": {
      border: "none"
    },
    [`@media (max-width: ${breakpoints.md}px)`]: {
      marginLeft: 0,
      marginTop: "8px",
      paddingLeft: 0
    },
  },
  downloadTeamsDisabledBtn: {
    extend: "downloadTeamsBtn",
    "& svg": {
      "& path": {
        stroke: colors.darkGrey,
      },
    },
  }
});

export default styles;
